const CSV = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            fill="currentColor"
            d="M19.4 2.01a2 2 0 0 1 1.796 1.989v16.003l-.01.204A2 2 0 0 1 19.4 21.99l-.204.01H6.209l-.204-.01a2 2 0 0 1-1.785-1.785l-.01-.204v-2.069H2.946v-7.007h1.262V4a2 2 0 0 1 1.796-1.99L6.21 2h12.987l.204.01ZM6.21 3.498a.5.5 0 0 0-.5.5v6.927H16.5v7.007H5.71v2.069a.5.5 0 0 0 .5.5h12.986a.5.5 0 0 0 .5-.5V3.998a.5.5 0 0 0-.5-.5H6.209Zm1.182 9.474c-.848 0-1.456.636-1.456 1.456 0 .816.608 1.456 1.456 1.456.516 0 .968-.26 1.204-.66l-.476-.275c-.133.243-.408.395-.728.395-.548 0-.908-.38-.908-.916 0-.54.36-.92.908-.92.32 0 .592.153.728.4l.476-.276c-.24-.4-.692-.66-1.204-.66Zm2.435 0c-.48 0-.92.304-.92.832 0 .532.417.712.844.836.416.12.604.2.604.408 0 .156-.117.296-.448.296-.348 0-.544-.168-.644-.428l-.472.277c.153.415.529.691 1.1.691.596 0 1.015-.32 1.016-.844 0-.571-.472-.72-.916-.86-.423-.128-.531-.22-.532-.391 0-.16.136-.28.368-.28.284 0 .436.148.536.36l.464-.269a1.065 1.065 0 0 0-1-.628Zm2.054 2.857h.684l.944-2.8h-.604l-.68 2.151-.684-2.151h-.6l.94 2.8Z"
        />
    </svg>
);

export default CSV;
